import { apiDelete, apiGet, apiPost } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { buildQuery } from '../../framework/client/resource';

export const getVendorPurchaseInvoices = async (vendorId: string, parameters: Map<string, any>): Promise<any[]> => {
    let body: any = {};
    let queryParameters = '';

    const pagingParameters = new Map<string, string>();
    let queryString = ``;

    if (parameters) {
        const query = buildQuery(parameters, queryString, body, pagingParameters, undefined);
        queryParameters = query.queryParameters;
        body = query.body;
    }

    const response = await apiPost(`/api/resource/vendor/${vendorId}/invoices${queryParameters}`, body);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getPresignedUrlObjectS3 = async (resourceType: string, filename: string): Promise<any> => {
    const url = `/api/file/resource/${resourceType}/attachments/${filename}/presignedUrl`;
    const response = await apiGet(url);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getFileS3 = async (resourceType: string, attachmentId: string, attachmentName: string): Promise<Blob> => {
    const url = `/api/file/resource/${resourceType}/attachments/${attachmentId}_${attachmentName}/download`;
    const response = await apiGet(url);

    if (response.status === 200) {
        return (await response.blob()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getBudgetExportFile = async (fileName: string): Promise<Blob> => {
    const url = `/api/vehicle-cost-monthly-row/export/${fileName}`;
    const response = await apiGet(url);

    if (response.status === 200) {
        return (await response.blob()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getVehicleContractExportFile = async (fileName: string): Promise<Blob> => {
    const url = `/api/vehicle-contract/export/${fileName}`;
    const response = await apiGet(url);

    if (response.status === 200) {
        return (await response.blob()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getPurchaseInvoiceAttachment = async (fileName: string): Promise<Blob> => {
    const url = `/api/user/netvisor/purchaseinvoice/attachments/${fileName}`;
    const response = await apiGet(url);

    if (response.status === 200) {
        return (await response.blob()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const deleteFileS3 = async (resourceType: string, filename: string): Promise<void> => {
    try {
        const url = `/api/file/resource/${resourceType}/attachments/${filename}/delete`;
        await apiDelete(url);
    } catch (err) {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};
